import { Controller } from "@hotwired/stimulus"

// A photograph, full size, on click.
//
// THE MODAL IS BUILT WHEN IT IS OPENED, not rendered hidden in the page.
//
// modal_controller does two things on connect() that a pre-rendered hidden
// lightbox gets wrong. It takes the body scroll lock — so a page merely
// CONTAINING a lightbox would be unscrollable before anybody clicked. And
// its close() is `element.remove()`, so the first close would delete the
// markup and the second click would open nothing.
//
// Both are correct for a modal that arrives from the server when it is
// wanted and is thrown away when dismissed, which is every other modal
// here. Cloning a template on demand gives this one the same lifecycle
// without a request: connect() runs at the moment of opening because that
// is when the element enters the DOM, and remove() takes away a copy.
//
// THE IMAGE IS FETCHED ON OPEN, and this is the point of the feature rather
// than an optimisation on top of it. The show page displays a 320px crop
// (27KB); the full photo is 1200px (152KB). Putting a real `src` in the
// page would download the large one on every recipe view whether or not
// anybody clicks, which is more bytes than the page spent before the
// lightbox existed. data-src, swapped in here, means nobody who does not
// click pays anything at all.
export default class extends Controller {
  static targets = ["template"]

  open(event) {
    // Not on a modified click: cmd-click and middle-click on the enclosing
    // link should still do what the browser would do.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return

    event.preventDefault()

    const copy = this.templateTarget.content.firstElementChild.cloneNode(true)
    const image = copy.querySelector("img[data-src]")

    // BEFORE IT IS IN THE DOM, so the fetch starts with the element rather
    // than a frame later.
    if (image) {
      image.src = image.dataset.src
      image.removeAttribute("data-src")
    }

    document.body.appendChild(copy)
  }
}
